var map = {
	"./biz-cn": [
		37467,
		1685,
		1610
	],
	"./biz-cn.ts": [
		37467,
		1685,
		1610
	],
	"./biz-en": [
		82103,
		1685,
		5822
	],
	"./biz-en.ts": [
		82103,
		1685,
		5822
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 17075;
module.exports = webpackAsyncContext;